import React, {useState} from 'react';
import {
    makeStyles,
    Typography,
    Hidden,
    Toolbar,
    MenuItem,
    IconButton,
    MenuList,
    Popper,
    Grow,
    Paper,
    ClickAwayListener
} from "@material-ui/core";
import MuiAppBar from '@material-ui/core/AppBar';
import MenuIcon from '@material-ui/icons/Menu';
import Grid from "@material-ui/core/Grid";
import {TooltipCustom} from "../../component/common/TooltipCustom";

const useStyles = makeStyles(() => ({
    appBar: {
        backgroundColor: 'white',
        boxShadow: 'none',
    },
    logo: {
        "&:hover": {cursor: 'pointer'},
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    flex: {
        display: 'flex'
    },
    icon: {
        width: '40px',
        margin: 10,
        "&:hover": {cursor: 'pointer'}
    },
    button: {
        "&:hover": {cursor: 'pointer'}
    },
    textButton: {
        textTransform: 'none',
        textAlign: 'center',
        color: '#707070',
        fontSize: "18px",
        fontWeight: "inherit",
        "&:hover": {cursor: 'pointer'}
    },
    textButtonWithGreenBoder: {
        textTransform: 'none',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.26)',
        fontSize: "18px",
        fontWeight: "inherit",
        border: "1px solid #94C11F",
        borderRadius: "19px",
        backgroundColor: "rgba(0, 0, 0, 0.12)",
        //"&:hover": {cursor: 'pointer'}
    },
    menuOption: {
        textTransform: 'none',
        textAlign: 'center',
        color: '#707070',
        fontSize: "18px",
        fontWeight: "inherit",
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    menuOptionWithGreenBoder: {
        textTransform: 'none',
        textAlign: 'center',
        color: '#707070',
        fontSize: "18px",
        fontWeight: "inherit",
        marginLeft: 'auto',
        marginRight: 'auto',
        border: "1px solid #94C11F",
        borderRadius: "19px",
        padding: '1px 30px'
    },
    noWrap: {
        whiteSpace: "nowrap"
    },
}));

function AppBar({scrollTo}) {
    const classes = useStyles();
    const [locationMenu, setLocationMenu] = useState(null);

    const handleClose = (event) => {
        if (locationMenu && locationMenu.contains(event.target)) {
            return;
        }

        setLocationMenu(null);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setLocationMenu(null);
        }
    }

    return (
        <MuiAppBar position="sticky" className={classes.appBar}>
            <Toolbar>
                <Hidden only={["xs", "sm"]}>
                    <Grid container justifyContent={"center"} alignItems={"center"}>
                        <Grid item sm={4} md={4} lg={4} xl={4} className={classes.flex}>
                            <img alt={"Logo dans l'entreprise"}
                                 src={"/image/appbar/logo.png"}
                                 className={classes.logo}
                                 onClick={() => {
                                     scrollTo('/');
                                 }}
                            />
                        </Grid>
                        <Grid item sm={2} md={2} lg={2} xl={2}>
                            <Typography variant={'h5'} className={classes.textButton} onClick={() => {
                                scrollTo("/pourquoi-cyklad")
                            }}>
                                POURQUOI <span className={classes.noWrap}>CYKLAD ?</span>
                            </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} lg={2} xl={2}>
                            <Typography variant={'h5'} className={classes.textButton} onClick={() => {
                                scrollTo("/services")
                            }}>
                                SERVICES
                            </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} lg={2} xl={2}>
                            <Typography variant={'h5'} className={classes.textButtonWithGreenBoder}>
                                PORTAIL
                            </Typography>
                        </Grid>
                        <Grid item sm={2} md={2} lg={2} xl={2}>
                            <div className={classes.textButton}>
                                <a href="tel:04 48 20 15 10">
                                    <TooltipCustom title="04 48 20 15 10" interactive>
                                        <img alt={"Bouton pour"}
                                             src={"/image/appbar/IconAppel.png"}
                                             className={classes.icon}
                                        />
                                    </TooltipCustom>
                                </a>
                                <a href="mailto:soc@cyklad.fr">
                                    <TooltipCustom title="soc@cyklad.fr" interactive>
                                        <img alt={"Logo dans l'entreprise"} src={"/image/appbar/IconMail.png"}
                                             className={classes.icon}
                                        />
                                    </TooltipCustom>
                                </a>
                            </div>
                        </Grid>
                    </Grid>
                </Hidden>
                <Hidden only={['md', 'lg', 'xl']}>
                    <Grid container>
                        <Grid item xs={2} sm={2}>
                            <IconButton onClick={(event) => setLocationMenu(event.currentTarget)}>
                                <MenuIcon/>
                            </IconButton>
                            <Popper open={!!locationMenu} anchorEl={locationMenu} role={undefined} transition
                                    disablePortal>
                                {({TransitionProps, placement}) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <MenuList onKeyDown={handleListKeyDown}>
                                                    <MenuItem onClick={() => {
                                                        setLocationMenu(null);
                                                        scrollTo("/pourquoi-cyklad")
                                                    }} className={classes.flex}>
                                                        <Typography variant={'h5'} className={classes.menuOption}>
                                                            POURQUOI CYKLAD ?
                                                        </Typography>
                                                    </MenuItem>
                                                    <MenuItem onClick={() => {
                                                        setLocationMenu(null);
                                                        scrollTo("/services")
                                                    }} className={classes.flex}>
                                                        <Typography variant={'h5'} className={classes.menuOption}>
                                                            SERVICES
                                                        </Typography>
                                                    </MenuItem>
                                                    {/*<MenuItem onClick={() => {
                                                        setLocationMenu(null);
                                                    }} className={classes.flex}>
                                                        <Typography variant={'h5'}
                                                                    className={classes.menuOptionWithGreenBoder}>
                                                            PORTAIL
                                                        </Typography>
                                                    </MenuItem>*/}
                                                    <MenuItem className={classes.flex}>
                                                        <div className={classes.menuOption}>
                                                            <a href="tel:04 48 20 15 10">
                                                                <TooltipCustom title="04 48 20 15 10" interactive>
                                                                    <img alt={"Bouton pour"}
                                                                         src={"/image/appbar/IconAppel.png"}
                                                                         className={classes.icon}
                                                                         onClick={() => {
                                                                             setLocationMenu(null);
                                                                         }}
                                                                    />
                                                                </TooltipCustom>
                                                            </a>
                                                            <a href="mailto:soc@cyklad.fr">
                                                                <TooltipCustom title="soc@cyklad.fr" interactive>
                                                                    <img alt={"Logo dans l'entreprise"}
                                                                         src={"/image/appbar/IconMail.png"}
                                                                         className={classes.icon}
                                                                         onClick={() => {
                                                                             setLocationMenu(null);
                                                                         }}
                                                                    />
                                                                </TooltipCustom>
                                                            </a>
                                                        </div>
                                                    </MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </Grid>
                        <Grid item xs={10} sm={10} className={classes.flex}>
                            <img alt={"Logo dans l'entreprise"}
                                 src={"/image/appbar/logo.png"}
                                 className={classes.logo}
                            />
                        </Grid>
                    </Grid>
                </Hidden>
            </Toolbar>
        </MuiAppBar>
    )
}

export default AppBar
